// removed by extract-text-webpack-plugin
module.exports = {"preventScroll":"_2WyTguSp3ztKfJOEzXkvKC","container":"_3tFsWhUpTNz91fKQHaQMlM","inner":"_3WF4hGSk1qN46mJb4pJDfw","inner_small":"_1Ib2Ta-Y5nKPEnGSTuQr5u","inner_large":"_1xbMyjtA9oT-yFcaW4o3oE","backLinkBig":"thUantkJQNBx7PNlQbhkH","backLink":"_2_PIBlF8doYAht7a9cGb57"};


//////////////////
// WEBPACK FOOTER
// ../components/Overlay/style.module.less
// module id = 991
// module chunks = 0